import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import type { RootState } from "../../../../app/store";
import type { CheckoutStep } from "../../checkoutSlice";

const CheckoutSteps: React.FC = () => {
  const { t } = useTranslation();
  const currentStep = useSelector(
    (state: RootState) => state.checkout.currentStep
  );
  const completedSteps = useSelector(
    (state: RootState) => state.checkout.completedSteps
  );

  const steps: { key: CheckoutStep; labelKey: string; defaultLabel: string }[] =
    [
      {
        key: "billing",
        labelKey: "checkout.billingAddress",
        defaultLabel: "Billing Address",
      },
      {
        key: "shipping",
        labelKey: "checkout.shippingAddress",
        defaultLabel: "Shipping Address",
      },
      {
        key: "payment",
        labelKey: "checkout.paymentMethod",
        defaultLabel: "Payment",
      },
    ];

  const getStepClass = (stepKey: CheckoutStep): string => {
    let className = "checkout-step";
    if (stepKey === currentStep) {
      className += " active";
    } else if (completedSteps.includes(stepKey)) {
      className += " completed";
    }
    return className;
  };

  return (
    <nav
      className="checkout-steps-indicator"
      aria-label={t("checkout.stepsLabel", "Checkout Steps")}
    >
      <ol>
        {steps.map((step) => (
          <li key={step.key} className={getStepClass(step.key)}>
            <span className="step-label">
              {t(step.labelKey, step.defaultLabel)}
            </span>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default CheckoutSteps;
